<template>
  <div>
    <!-- ACCOUNT PROFILE -->
    <b-container v-if="user">
      <b-row>
        <b-col cols="12">
          <h1 class="font-weight-bold overflow-hidden">
            <span v-if="user.full_name" v-text="user.full_name" />
            <span v-else v-text="`@` + user.username" />
          </h1>
        </b-col>
      </b-row>

      <b-row>
        <b-col
          cols="3"
          md="2"
          lg="1"
          class="p-0 cursor"
          @click="$router.push('/influencer/following')"
        >
          <h5 class="m-0 user-following">{{ user.following_count }}</h5>
          <small class="grey-light">Following</small>
        </b-col>
        <b-col cols="3" md="2" lg="1" class="p-0">
          <h5 class="m-0 user-vipcount">{{ user.vip_list_count }}</h5>
          <small class="grey-light">VIP List</small>
        </b-col>
        <b-col cols="3" md="2" lg="1" class="p-0">
          <h5 class="m-0 user-vellos">{{ user.vellos_ready_count }}</h5>
          <small class="grey-light">Vellos Ready</small>
        </b-col>
      </b-row>
    </b-container>

    <!-- VELLOS AVAILABLE -->
    <list-vellos-ready />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ListVellosReady from '../../components/ListVellosReady'

export default {
  components: {
    ListVellosReady,
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
  },
  methods: {
    ...mapActions({
      getAuthenticatedUser: 'auth/getAuthenticatedUser',
    }),
  },

  created() {
    this.getAuthenticatedUser()
  },
}
</script>

<style lang="scss" scoped></style>
